// Whether a task is authorized, as far as a LIST row can tell.
//
// The rows of `GET /admin/tasks` carry no authorization record: the signature
// lives in `task_authorizations` and the list does not join it. What the row
// does carry is `workflow_state`, and authorizing IS the move from `proposed`
// to `ready` — nothing else takes a task out of `proposed` into the queue. So:
//
//   proposed                  → not authorized: the queue does not hand it out
//   ready and everything after → went through authorization
//   discarded                 → unknown: it can be thrown away from either side,
//                               and the row does not say which
//
// THE ONE CASE THIS CANNOT SEE: a task from a LEGACY tier, older than signed
// authorizations, reached `ready` without one. It reads as authorized here,
// because in the queue it behaves exactly like one. The task's own screen and
// the commit trace are where the actual signature is shown.

export const AUTHORIZED = 'authorized';
export const UNAUTHORIZED = 'unauthorized';

// Whether a row can be authorized from where it is shown: a proposal, with
// the door it goes through — its tier's breakdown, or, for a one-off task, its
// own route. A planned row without a tier has no door.
export function canBeAuthorized(task) {
    if (task?.workflow_state !== 'proposed') return false;
    return task.modality === 'one_off' || task.tier_id != null;
}

export function authorizationOf(workflowState) {
    if (workflowState === 'proposed') return UNAUTHORIZED;
    if (workflowState === 'discarded' || workflowState == null) return null;
    return AUTHORIZED;
}
